import React from "react";
import DetailsQuote from "../../components/Pages/Quotes/Details/Details";

const QuoteDetails = () => {
  return (
    <div>
      <DetailsQuote />
    </div>
  );
};

export default QuoteDetails;
